import { render, staticRenderFns } from "./BlogCard1.vue?vue&type=template&id=81f92eae"
import script from "./BlogCard1.vue?vue&type=script&lang=js"
export * from "./BlogCard1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports